import { Select } from "antd";
import { useTranslation } from "react-i18next";
import { Props } from "../../../common/entity/props.entity";
import { payWayArr } from "../enum/pay.way.enum copy";

const { Option } = Select;

export const SingleSelectPayWay = (props: Props) => {
	const { t } = useTranslation();
	return (
		<div>
			<Select style={{ width: 200 }} onChange={props.onChange} allowClear placeholder={t("payWay")}>
				{Object.keys(payWayArr).map((item) => (
					<Option key={item} value={item}>
						{t(payWayArr[Number(item)])}
					</Option>
				))}
			</Select>
		</div>
	);
};
